import React from "react";
import i18next from "i18next";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { useTranslation } from "react-i18next";
import styles from "./LanguageSelection.module.scss";

const languageMap = {
  en: { code: "EN", label: "English", flag: "gb", dir: "ltr" },
  fr: { code: "FR", label: "Français", flag: "fr", dir: "ltr" },
};

const FlagIcon = ({ flag }) => {
  if (flag === "fr") {
    return (
      <svg className={styles.flagSvg} viewBox="0 0 24 18" aria-hidden="true">
        <rect width="8" height="18" fill="#0055a4" />
        <rect x="8" width="8" height="18" fill="#ffffff" />
        <rect x="16" width="8" height="18" fill="#ef4135" />
      </svg>
    );
  }

  return (
    <svg className={styles.flagSvg} viewBox="0 0 24 18" aria-hidden="true">
      <rect width="24" height="18" fill="#012169" />
      <path d="M0 0 24 18M24 0 0 18" stroke="#ffffff" strokeWidth="4" />
      <path d="M0 0 24 18M24 0 0 18" stroke="#c8102e" strokeWidth="2.4" />
      <path d="M12 0v18M0 9h24" stroke="#ffffff" strokeWidth="7" />
      <path d="M12 0v18M0 9h24" stroke="#c8102e" strokeWidth="4" />
    </svg>
  );
};

const LanguageSelect = () => {
  const { i18n, t } = useTranslation();
  const selected = languageMap[i18n.language] ? i18n.language : "en";
  const [menuAnchor, setMenuAnchor] = React.useState(null);

  React.useEffect(() => {
    document.body.dir = languageMap[selected].dir;
  }, [selected]);

  return (
    <div className={styles.languageSelectRoot}>
      <Button
        className={styles.languageButton}
        onClick={({ currentTarget }) => setMenuAnchor(currentTarget)}
        aria-label={t("Select language")}
      >
        <span className={styles.flag} aria-hidden="true">
          <FlagIcon flag={languageMap[selected].flag} />
        </span>
        <span className={styles.code}>{languageMap[selected].code}</span>
        <ArrowDropDown className={styles.chevron} fontSize="small" />
      </Button>
      <Popover
        open={!!menuAnchor}
        anchorEl={menuAnchor}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List className={styles.languageMenu}>
          {Object.keys(languageMap).map((item) => (
            <ListItem
              button
              key={item}
              selected={item === selected}
              className={styles.languageOption}
              onClick={() => {
                i18next.changeLanguage(item).finally(() => setMenuAnchor(null));
              }}
            >
              <span className={styles.flag} aria-hidden="true">
                <FlagIcon flag={languageMap[item].flag} />
              </span>
              <span className={styles.code}>{languageMap[item].code}</span>
              <span className={styles.optionLabel}>{languageMap[item].label}</span>
            </ListItem>
          ))}
        </List>
      </Popover>
    </div>
  );
};

export default LanguageSelect;
